import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, UserService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OwnerStmtService } from '../owner-stmt.service';
import { OwnerStmt } from '../owner-stmt';
import { PropertyService } from '@app/_components/property/property.service';
import { StatementsComponent } from '@app/_components/owner-stmt-view/statements/statements.component';

@Component({
    selector: 'app-owner-stmt',
    templateUrl: './owner-stmt.component.html',
    styleUrls: ['./owner-stmt.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OwnerStmtComponent implements OnInit {

    properties: any;
	users: any;
	destReservationId: any;
	isDestReservationId = false;
	destTitle = "Destination Reservation";


	constructor(
		private propertyService: PropertyService,
		private primengConfig: PrimeNGConfig,
		private ownerStmtService: OwnerStmtService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private userService: UserService,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.ownerStmt = data.ownerStmt,
			this.ownerStmtId = data.ownerStmt?.ownerStmtId;
			this.statuses = ownerStmtService.statuses;
	}

	@Input() ownerStmt: OwnerStmt;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	ownerStmtId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'ownerStmtId': [],
		'shortTermRentalId': [{ type: 'required', message: 'Required' }],
		'propertyCode': [],
		'statementDate': [],
		'stmtStatus': [],
		'ownerName': [],
		'ownerAdrStreet': [],
		'ownerAdrCity': [],
		'ownerAdrState': [],
		'ownerAdrPostal': [],
		'propertyAdrStreet': [],
		'propertyAdrCity': [],
		'propertyAdrState': [],
		'propertyAdrPostal': [],
		'ownerNotes': [],
		'opsNotes': [],
		'revProgram': [],
		'userId': [{ type: 'required', message: 'Required' }],
		'destReservationId': [],

	};

	ngOnInit() {
		this.fetchProperties();
		this.fetchUsers();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole ownerStmt object
		if (this.ownerStmt) {
			this.ownerStmtId = this.ownerStmt.ownerStmtId;
			this.fixDates();
			this.form1.patchValue(this.ownerStmt);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.ownerStmtId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.ownerStmtService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ownerStmt = res.data.ownerStmt;
						this.ownerStmtId = this.ownerStmt.ownerStmtId;
						this.doAdd.emit(this.ownerStmt);
					},
					(err: any) => {
						console.log('ownerStmt-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('ownerStmt: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			this.form1.value.ownerStmtId = this.ownerStmtId;
			this.ownerStmtService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ownerStmt = res.data.ownerStmt;
						this.doUpdate.emit(this.ownerStmt);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.ownerStmtService.delete(this.ownerStmt.ownerStmtId)
				.subscribe(
					(res: any) => {
						console.log('ownerStmt-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.ownerStmt);
					},
					(err: any) => {
						console.log('ownerStmt-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			ownerStmtId: [this.ownerStmtId],
			shortTermRentalId:  ['', Validators.required],
			propertyCode: [],
			statementDate: [],
			stmtStatus: [],
			ownerName: [],
			ownerAdrStreet: [],
			ownerAdrCity: [],
			ownerAdrState: [],
			ownerAdrPostal: [],
			propertyAdrStreet: [],
			propertyAdrCity: [],
			propertyAdrState: [],
			propertyAdrPostal: [],
			ownerNotes: [],
			opsNotes: [],
			revProgram: [],
			userId:['', Validators.required],
			destReservationId: [],

		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.ownerStmt.ownerStmtDate = moment(this.ownerStmt.ownerStmtDate).toDate();
	}

	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.findAllSummary()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.properties;
							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}

	fetchUsers() {
		if (!this.users || this.users === undefined || this.users.length < 1) {
			try {
				this.userService.findAll()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.users = res.data.users;
							return this.users;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}

	//View Statement

	/*********
		* Edit Button
		*
		*/
		onOpenFormEdit() {

			const dialogConfig = new MatDialogConfig();
	
			// settings
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;
			dialogConfig.maxWidth = '100vw'
			dialogConfig.maxHeight = '100vh'
			dialogConfig.height = '95vh'
			dialogConfig.width = '2150px'
			dialogConfig.panelClass = 'my-class'
			
	
			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				ownerStmt: this.ownerStmt,
				title: 'Edit OwnerStmt'
			};
	
			// open the popup and get a reference to it called dialogRef
			let dialogRef = this.dialog.open(StatementsComponent, dialogConfig );
			
	
			// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
			dialogRef.componentInstance.doUpdate.subscribe(
				data => {
					console.log('Dialog output:', data);
	
					// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//	this.updateOwnerStmtCB(data);
	
					// close the dialogBox
					dialogRef.close();
				});
	
			dialogRef.componentInstance.doDelete.subscribe(
				data => {
					console.log('Dialog output:', data);
	
					// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
					//this.deleteOwnerStmtCB(data);
	
					// close the dialogBox
					dialogRef.close();
				});
		}
	

	//Reservation ID

	destReservationInfoItem(event : any){
		console.log("Destination Reservation : "+ JSON.stringify(event));
		this.isDestReservationId = false;
		this.destReservationId = event.reservationId;
		this.form1.patchValue({
			//destTotalNights: event.numNights,
		});
	}

	reservationInfoItem(event : any){
		console.log("reservation reservation : "+ JSON.stringify(event));
		this.isDestReservationId = false;
		this.destReservationId = event.reservationId;
		this.form1.patchValue({
			firstName: event.guestProfile.firstName,
			lastName: event.guestProfile.lastName,
			emailAddress: event.guestProfile.emailAddress,
			adr1: event.guestProfile.adrStreet,
			adr2: event.guestProfile.adrStreet2,
			adrCity: event.guestProfile.adrCity,
			adrState: event.guestProfile.adrState,
			adrCountry: event.guestProfile.adrCountry,
			mobilePhone: event.primaryMobilePhone,
			checkInDate: moment(event.checkInDateTime).toDate(),
			checkOutDate: moment(event.checkOutDateTime).toDate(),
			shortTermRentalId: event.shortTermRentalId,
			propertyCode: event.propertyCode,
		});
	}
}
